var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var FechaDisponibilidadProducto = function (_a) {
    var fecha = _a.fecha;
    return (React.createElement(AvisoFechaDeDisponibilidad, null,
        "Podr\u00E1s comprar este art\u00EDculo a partir del ",
        fecha));
};
var AvisoFechaDeDisponibilidad = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  color: ", ";\n"], ["\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.alert;
});
export default FechaDisponibilidadProducto;
var templateObject_1;
